"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "8", height: "12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 .763L7.237 0 0 7.237.763 8 8 .763zm0 4.065L7.172 4 4 7.172 4.828 8 8 4.828z", fill: "#404040" }))); };
exports.default = Component;
//# sourceMappingURL=Resize.js.map